import "./Navbar.css";
import { useNavigate } from "react-router-dom";
import { useGoodPricesCount } from "./GoodPrices";

function Navbar() {
  const navigate = useNavigate();
  const goodPricesCount = useGoodPricesCount();

  return (
    <div className="navbar">
      <div className="navbar__button" onClick={() => navigate("/")}>
        Hauptseite
      </div>
      <div className="navbar__button" onClick={() => navigate("/good-prices")}>
        Gute Preise
        <span className="navbar__buttonCount">{goodPricesCount}</span>
      </div>
      <div className="navbar__button" onClick={() => navigate("/parser")}>
        Parser
      </div>
      <div className="navbar__button" onClick={() => navigate("/dataflow")}>
        Datenfluss
      </div>
      <div className="navbar__button" onClick={() => navigate("/requests")}>
        Anfragen
      </div>
      {/* <div className="navbar__button" onClick={() => navigate("/upload")}>
        Upload
      </div> */}
      <div
        className="navbar__button"
        onClick={() => navigate("/search-car-by-spec")}
      >
        Ähnliche Autos
      </div>
      <div className="navbar__button" onClick={() => navigate("/time-master")}>
        TimeMaster
      </div>
      <div className="navbar__button" onClick={() => navigate("/settings")}>
        Einstellungen
      </div>
      <div
        className="navbar__button"
        onClick={() => (window.location.href = "https://gebet-zeiten.de/")}
      >
        Gebetzeiten
      </div>
    </div>
  );
}

export default Navbar;
